/** Sentinel for muscle / equipment chip popovers — rows with no tags. */
export const LIB_EX_UNSPECIFIED = '__unspecified__';

/** Sort options for the Library Exercises tab. */
export type ExLibSortKey = 'name-asc' | 'name-desc' | 'yours-first' | 'yours-last';

export const LIB_EX_SORT_OPTIONS: { id: ExLibSortKey; label: string }[] = [
  { id: 'name-asc', label: 'Name (A→Z)' },
  { id: 'name-desc', label: 'Name (Z→A)' },
  { id: 'yours-first', label: 'Yours first' },
  { id: 'yours-last', label: 'Yours last' },
];

export const VALID_EX_SORT_KEYS: ReadonlyArray<ExLibSortKey> = [
  'name-asc',
  'name-desc',
  'yours-first',
  'yours-last',
];

export type ExViewState = {
  search: string;
  muscle: string[];
  equipment: string[];
  createdBy: Array<'You' | 'Bravos'>;
  sort: ExLibSortKey;
  page: number;
};

/** Workouts tab sort + filter primitives. */
export type WorkoutSortColumn = 'name' | 'createdAt' | 'exercises';
export type WorkoutSortDirection = 'asc' | 'desc';
export type WorkoutDurationBucket = 'lt30' | '30to60' | 'gt60';
export type WorkoutDateFilterType = 'exact' | 'before' | 'after' | 'between';

export const VALID_WORKOUT_SORT_COLS: ReadonlyArray<WorkoutSortColumn> = ['name', 'createdAt', 'exercises'];
export const VALID_WORKOUT_SORT_DIRS: ReadonlyArray<WorkoutSortDirection> = ['asc', 'desc'];
export const VALID_WORKOUT_DURATION_BUCKETS: ReadonlyArray<WorkoutDurationBucket> = ['lt30', '30to60', 'gt60'];
export const VALID_WORKOUT_DATE_TYPES: ReadonlyArray<WorkoutDateFilterType> = [
  'exact',
  'before',
  'after',
  'between',
];

/** Library Workout Plans duration — 4-bucket multi-select. */
export type WorkoutPlanDurationBucket = '1-4' | '5-8' | '9-12' | '13+';

export const VALID_PLAN_DURATION_BUCKETS: ReadonlyArray<WorkoutPlanDurationBucket> = [
  '1-4',
  '5-8',
  '9-12',
  '13+',
];

export type LibPlanSortKey =
  | 'newest'
  | 'oldest'
  | 'name-asc'
  | 'name-desc'
  | 'duration-desc'
  | 'duration-asc'
  | 'most-wk'
  | 'fewest-wk';

export const PLAN_DURATION_BUCKET_LABELS: Record<WorkoutPlanDurationBucket, string> = {
  '1-4': '1–4 wks',
  '5-8': '5–8 wks',
  '9-12': '9–12 wks',
  '13+': '13+ wks',
};

export type WkViewState = {
  search: string;
  muscle: string[];
  equipment: string[];
  durations: WorkoutDurationBucket[];
  dateFilter: string;
  dateFilterType: WorkoutDateFilterType;
  dateFilterEnd: string;
  sortColumn: WorkoutSortColumn;
  sortDirection: WorkoutSortDirection;
  page: number;
};

/** Library empty-state variant (handoff §4.4). */
export type LibEmptyVariant = 'true-empty' | 'filtered-empty-exercises' | 'no-match' | null;

export type WorkoutLibraryRow = {
  id: string;
  name?: string;
  createdBy?: string | null;
  createdAt?: string;
  exerciseCount?: number;
  focusTags?: string[];
  equipmentTags?: string[];
};
